import { Injectable, inject } from '@angular/core';
import type { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import type { Observable } from 'rxjs';
import { catchError, EMPTY, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { isStatusBypassed } from '@shared/common';
import { PublicPagesService, SessionService } from '@security/user';

enum HTTP_STATUS {
  NOT_AUTHENTICATED = 401,
  NOT_AUTHORIZED = 403,
}

@Injectable()
export class HandleHttpUnauthorizedInterceptor implements HttpInterceptor {
  private readonly session = inject(SessionService);
  private readonly router = inject(Router);
  private readonly publicPages = inject(PublicPagesService);

  private readonly logoutStatusCodes = [HTTP_STATUS.NOT_AUTHENTICATED, HTTP_STATUS.NOT_AUTHORIZED];

  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        const isBypassed = isStatusBypassed(request.headers)(error.status);

        if (isBypassed) {
          return throwError(() => error);
        }

        if (this.userShouldBeLoggedOut(error)) {
          this.logoutUser();
          return EMPTY;
        }

        return throwError(() => error);
      }),
    );
  }

  private logoutUser() {
    this.session.destroy();

    setTimeout(() => this.router.navigate(['/logout']));
  }

  private userShouldBeLoggedOut(error: HttpErrorResponse) {
    return !this.publicPages.userIsOnPublicPage() && this.logoutStatusCodes.includes(error.status);
  }
}
